import { useState, useEffect } from 'react';

export const useTailwindBreakpoint = () => {
  const [size, setSize] = useState<'xs' | 'sm' | 'md' | 'lg'>('xs');

  useEffect(() => {
    const handleBreakpointChange = () => {
      if (window.innerWidth >= 1200) { 
        setSize('lg');
      } else if (window.innerWidth >= 768) { 
        setSize('md');
      } else if (window.innerWidth >= 640) { 
        setSize('sm');
      } else {
        setSize('xs');
      }
    };

    window.addEventListener('resize', handleBreakpointChange);
    handleBreakpointChange();

    return () => {
      window.removeEventListener('resize', handleBreakpointChange);
    };
  }, []);

  return size;
};